import _styled from "styled-components";
import React, {useState} from "react";
import {execFn} from "../../../common/generic-react.functions.js";
import Icon from "../../atoms/icon/icon.component.js";
import {ExpanderChildContainer, ExpanderContainer, ExpanderTitleContainer} from "./expander.styles.js";
function Expander({
  children,
  disabled,
  readOnly,
  text,
  show,
  onExpand,
  onCollapse
}) {
  const [isOpen, setIsOpen] = useState(show);
  const onClick = () => {
    if (readOnly || disabled) {
      return;
    }
    if (isOpen) {
      execFn(onCollapse);
    } else {
      execFn(onExpand);
    }
    setIsOpen(!isOpen);
  };
  return /* @__PURE__ */ React.createElement(ExpanderContainer, null, /* @__PURE__ */ React.createElement(ExpanderTitleContainer, {
    disabled: !!disabled,
    onClick
  }, /* @__PURE__ */ React.createElement(_StyledDiv, null, text), /* @__PURE__ */ React.createElement(Icon, {
    name: isOpen ? "angle-up" : "angle-down"
  })), /* @__PURE__ */ React.createElement(ExpanderChildContainer, {
    isOpen: !!isOpen
  }, children));
}
export default Expander;
var _StyledDiv = _styled("div").withConfig({
  displayName: "expandercomponent___StyledDiv",
  componentId: "sc-fv5sr4-0"
})({
  marginRight: "0.5rem"
});
